import axios from 'axios';

export const useFetchStatePartners = async (language: string, partnerState: string): Promise<any> => {
    const data = await axios.post(
        `${process.env.DRUPAL_URL}/graphql`,
        {
            query: `query fetchStatePartners($country: String!, $state: String!) {
                state_partners(country: $country, state: $state) {
                            data
                        }
                    }
            `,
            variables: {
                country: language,
                state: partnerState,
            },
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    const result = JSON.parse(data?.data?.data?.state_partners?.data);
    return result ?? {};
};
